import { ChangeEvent, ComponentProps, useEffect, useRef, useState } from "react";

type OptionType = { id: number; full_name: string; }
type MutliDropdownProps = {
  options: Array<OptionType>;
  label: string;
} & ComponentProps<'select'>

export const MultiDropdown = ({ options, label, ...rest }: MutliDropdownProps) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [open, setOpen] = useState(false)
  const handleSelectionChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
    setSelectedOptions(selectedValues);
  };
  const handleRemoveItem = (itemToRemove: string) => {
    console.log('======>', itemToRemove)
    // const removeState = selectedOptions.filter(item => item !== itemToRemove)
    setSelectedOptions(selectedOptions.filter(item => {
      console.log(item)
      const prevState = JSON.parse(item) as OptionType
      return prevState.full_name !== itemToRemove
    }));
  };
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  return (
    <div className="relative" ref={ref}>
      {label && <label className="mb-2 text-xs">{label}</label>}
      <div onClick={() => setOpen(!open)} className="flex flex-wrap border rounded-md text-xs p-2 w-full">
        {selectedOptions.length === 0 && (
          <span>انتخاب کنید</span>
        )}
        {selectedOptions.map((item, index) => {
          const { full_name, id } = JSON.parse(item)
          return (
            <button
              key={'selected_options_' + index}
              className="bg-cyan-500 text-white py-2 px-3 mx-1 rounded-xl flex"
              onClick={() => handleRemoveItem(full_name)}
              value={id}
              name={rest.name}
              type="button"
            >
              <span className="ml-1">x</span>
              <span>{full_name}</span>
            </button>
          )
        })}
      </div>
      {open && (
        <select {...rest} className="absolute right-0 left-0 border shadow-inner text-sm z-30" multiple value={selectedOptions} onChange={handleSelectionChange}>
          {options.map((option: OptionType, index) => (
            <option key={index} value={JSON.stringify({ id: option.id, full_name: option.full_name })}>
              {option.full_name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}